import type { ValidationResult } from '@openx/components-targeting/Targeting/shared/BulkAdd/types';
import { Actions, type ListData } from '@openx/types/inventoryList';
import type { Dispatch } from 'react';
import type { Action } from './types';

export const dispatchBulkAdd = (dispatch: Dispatch<Action>, validMappedItems: ListData[]) => {
  dispatch({ type: Actions.ADD_ITEMS, payload: validMappedItems });
};
export const dispatchValidate = (dispatch: Dispatch<Action>, validationResult?: ValidationResult) => {
  dispatch({ type: Actions.VALIDATE, payload: validationResult });
};
